import { render } from "./IconleftTextright.vue?vue&type=template&id=38f31ac3&scoped=true"
import script from "./IconleftTextright.vue?vue&type=script&lang=js"
export * from "./IconleftTextright.vue?vue&type=script&lang=js"

import "./IconleftTextright.vue?vue&type=style&index=0&id=38f31ac3&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38f31ac3"]])

export default __exports__